import * as React from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
import styled from 'styled-components';
import { Link } from '@helpcenter/analytics-components/src/link';
import * as mixins from '@helpcenter/styles/src/mixins';
import { FormattedMessage } from 'react-intl-next';
import { di } from 'react-magnetic-di';
import type { RequestTypeSuggestion } from 'state/persisted/request-type-suggestion';
import { useIsPageInEditMode } from 'view/layout-next/controllers';
import { AnalyticsContext } from '@atlaskit/analytics-next';
import { token } from '@atlaskit/tokens';
import messages from './messages';

interface ListItemBodyProps extends RequestTypeSuggestion {
    onClick: () => void;
    isEmbeddedRoute?: boolean;
}

const RecentFormsListItem: React.FunctionComponent<ListItemBodyProps> = ({
    portalId,
    portalName,
    name,
    descriptionHtml,
    onClick,
    isEmbeddedRoute,
    id: requestTypeId,
}) => {
    di(useIsPageInEditMode);
    const [isPageInEditMode] = useIsPageInEditMode();

    return (
        <AnalyticsContext data={{ attributes: { requestTypeId } }}>
            <>
                {isPageInEditMode ? (
                    <Title>
                        <FormattedMessage {...messages.linkText} values={{ portalName, formName: name }} />
                    </Title>
                ) : (
                    // eslint-disable-next-line @atlassian/a11y/click-events-have-key-events, @atlassian/a11y/no-static-element-interactions, styled-components-a11y/anchor-is-valid, styled-components-a11y/click-events-have-key-events, styled-components-a11y/no-static-element-interactions -- Disabling existing violation, should be fixed when revisited.
                    <FormLink
                        to={`/portal/${portalId}/create/${requestTypeId}`}
                        onClick={onClick}
                        actionSubjectId="suggestionRequestType"
                        target={isEmbeddedRoute ? '_blank' : undefined}
                    >
                        <FormattedMessage {...messages.linkText} values={{ portalName, formName: name }} />
                    </FormLink>
                )}
                {/* Safe to use dangerouslySetInnerHTML as the HTML is sanitised by Jira */}
                <Description dangerouslySetInnerHTML={{ __html: descriptionHtml }} />
            </>
        </AnalyticsContext>
    );
};

export default RecentFormsListItem;

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const FormLink = styled(Link)`
    color: ${(props) => token('color.link', props.theme.color)};
`;

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const Description = styled.div`
    & p {
        ${mixins.clamp};
    }
`;

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const Title = styled.div`
    color: ${(props) => token('color.link', props.theme.color)};
`;
